var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "line-height-reset my-0 py-0" },
    [
      _c(
        "small",
        { staticClass: "line-height-reset" },
        [
          _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.label))]
          }),
        ],
        2
      ),
      _c("ais-numeric-menu", {
        attrs: { attribute: _vm.attribute, items: _vm.mappedOptions },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ items, refine }) {
              return [
                _c(
                  "ul",
                  {
                    staticClass:
                      "numeric-menu list-unstyled d-flex align-items-center m-0",
                  },
                  [
                    _vm.icons
                      ? _vm._l(items, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.value,
                              staticClass: "numeric-menu__item-icon",
                              class: { active: item.isRefined },
                            },
                            [
                              _c("a", {
                                staticClass:
                                  "numeric-menu__icon mdi mdi-24px px-1",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return refine(item.value)
                                  },
                                },
                              }),
                            ]
                          )
                        })
                      : _vm._l(items, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.value,
                              staticClass: "numeric-menu__item-text",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "numeric-menu__icon circle xxs flex-center d-inline-flex text-sm",
                                  class: item.isRefined
                                    ? "bg-primary text-light font-weight-semi"
                                    : "text-body",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return refine(item.value)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.label))]
                              ),
                            ]
                          )
                        }),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }